import styles from './Spinner.module.css';

/**
 * The loading arc of design system § 14.
 *
 * `label` is required: a spinner with no accessible name announces nothing, and
 * a reader who cannot see it learns only that the screen went quiet. The
 * element is a `status`, so the name is announced politely rather than
 * interrupting.
 */

interface SpinnerProps {
  label: string;
  size?: 16 | 24 | 32;
}

export function Spinner({ label, size = 24 }: SpinnerProps) {
  return (
    <span role="status" aria-live="polite">
      <span className={styles.spinner} data-size={size} aria-hidden="true" />
      <span hidden>{label}</span>
    </span>
  );
}
